import React from 'react';

const Input = ({
  value,
  onChange,
  onKeyPress,
  placeholder,
  disabled = false,
  className = '',
  type = 'text',
  autoFocus = false
}) => {
  const baseStyles = "p-1 text-sm";
  const disabledStyles = disabled ? "bg-gray-50" : "";
  const finalClassName = `${baseStyles} ${disabledStyles} ${className}`;

  return (
    <input
      type={type}
      className={finalClassName}
      value={value}
      onChange={onChange}
      onKeyPress={onKeyPress}
      placeholder={placeholder}
      disabled={disabled}
      autoFocus={autoFocus}
    />
  );
};

export default Input; 